export const restoreAll = "K_a";
export default {restoreAll};